/* eslint-disable  */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string*/
import {
  GetDropOptions,
  uploadVerificationDocuments,
  getVerificationDocuments,
  getConfigDetails,
  getNAATAccessLink,
} from '../../api/user';
import i18n from '../../i18n';
import React from 'react';
import Compressor from 'compressorjs';
import jsPDF from 'jspdf';

import { OptionInterface, SecretValues, StateProvince } from '../../interface/CustomerInformationInterface';
import { IdentityInterface, IncomeInterface, ResidenceInterface, StgIdentityRecord, StgCustomerResponse } from '../../interface/CustomerInformationInterface';
import { DecryptedData } from '../../interface/DecryptInterface';
import { createDecipheriv } from 'crypto';

const GetDropDownOptions = async (
  setTypeOfIncomeOptions: (options: OptionInterface[]) => void,
  setJobTypeOptions: (options: OptionInterface[]) => void,
  setGenderDropOptions: (options: OptionInterface[]) => void,
  setMaritalStatusDropOptions: (options: OptionInterface[]) => void,
  setRacPromotionDropOptions: (options: OptionInterface[]) => void,
  setResidenceRadioOption: (options: OptionInterface[]) => void,
  setResidenceTenureTypeOption: (options: OptionInterface[]) => void,
  setStateOption: (options: OptionInterface[]) => void,
  setStateDetails: (options: StateProvince[]) => void
) => {
  const language = window.sessionStorage.getItem("language")
  const optionTemplate = [{
    label: (language == 'es-MX' || language == 'es-US') ? 'seleccionar' : 'select',
    value: ''
  }]
  const dofAuthSessionValue = window.sessionStorage.getItem('dofAuthValues');
  const sessionStorageValues = dofAuthSessionValue
    ? JSON.parse(dofAuthSessionValue)
    : null;

  const isStoreCodeFlow = window.sessionStorage.getItem('authKey')?.length ? false : true;
  console.log('isStoreCodeFlow ', isStoreCodeFlow);
  const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');

  const dropOptionsPayload = {
    references: [
      'RELATIONSHIP_TYPE',
      'RESIDENCE_TENURE_TYPE',
      'INCOME_SOURCE_TYPE',
      'JOB_TYPE',
      'MARITAL_STATUS_TYPE',
      'REFERRAL_SOURCE_TYPE',
      'RESIDENCE_TYPE',
      'GENDER_TYPE',
    ],
    status: 'Y',
    country: 'ALL',
  };

  try {
    const getDropOptionsRes = await GetDropOptions(
      dropOptionsPayload,
      isStoreCodeFlow,
      accessToken
    );
    console.log('getDropOptionsRes ', getDropOptionsRes);

    const language = window.sessionStorage.getItem('language')
    const mapOptions = (
      dataArray: any[],
      setter: (options: OptionInterface[]) => void
    ) => {
      const options: OptionInterface[] = [];
      if (Array.isArray(dataArray)) {
        options.push({
          label: i18n.t('select'),
          value: ''
        })
        dataArray.forEach((el) => {
          options.push({
            label: (language == 'es-MX' || language == 'es-US') ? el.descSpanish : el.description,
            value: el.referenceCode,
          });
        });
      }
      setter(options);
    };

    mapOptions(getDropOptionsRes?.data?.jobType, setJobTypeOptions);
    mapOptions(
      getDropOptionsRes?.data?.maritalStatusType,
      setMaritalStatusDropOptions
    );
    mapOptions(
      getDropOptionsRes?.data?.referralSourceType,
      setRacPromotionDropOptions
    );
    mapOptions(getDropOptionsRes?.data?.genderType, setGenderDropOptions);
    mapOptions(getDropOptionsRes?.data?.stateOptions, setStateOption);
    const options: OptionInterface[] = optionTemplate;
    getDropOptionsRes?.data?.stateOptions.map((el: any) => {
      if (el.countryCode == 'MX') {
        options.push({
          label: el.abbreviation,
          value: el.abbreviation
        })
      }
    })
    setStateOption(options);
    setStateDetails(getDropOptionsRes?.data?.stateOptions);

    const residenceOption: OptionInterface[] = [{
      label: i18n.t('select'),
      value: ''
    }];
    getDropOptionsRes?.data?.residenceTenureType.map((el: any) => {
      if (['LTTM', 'BOTY', 'BTFY', 'MTFY'].includes(el.referenceCode)) {
        residenceOption.push({
          label: (language == 'es-MX' || language == 'es-US') ? el.descSpanish : el.description,
          value: el.referenceCode
        })
      }
    })
    setResidenceTenureTypeOption(residenceOption);

    const incomeOption: OptionInterface[] = [{
      label: i18n.t('select'),
      value: ''
    }];
    getDropOptionsRes?.data?.incomeSourceType.map((el: any) => {
      if (['PAYREC', 'EMPCERT', 'ACCSTAT', 'PURREC', 'BANKTRANS', 'PENSTAT', 'OTHER'].includes(el.referenceCode)) {
        incomeOption.push({
          label: (language == 'es-MX' || language == 'es-US') ? el.descSpanish : el.description,
          value: el.referenceCode
        })
      }
    })
    setTypeOfIncomeOptions(incomeOption);



    const residenceRadioOption: any[] = [];
    if (Array.isArray(getDropOptionsRes?.data?.residenceType)) {
      getDropOptionsRes.data.residenceType.forEach((el: any) => {
        const label = (language === 'es-MX' || language === 'es-US')
          ? el.descSpanish
          : el.description;

        if (el.description == 'Family/Friend') {
          residenceRadioOption.push({
            label: label,
            value: el.referenceCode,
            displayseq: el.displaySeq
          });
        } else {
          // Capitalize only the first letter of the description
          const familyFriendLabel = (language === 'es-MX' || language === 'es-US')
            ? el.descSpanish.charAt(0).toUpperCase() + el.descSpanish.slice(1).toLowerCase()
            : el.description.charAt(0).toUpperCase() + el.description.slice(1).toLowerCase();

          residenceRadioOption.push({
            label: familyFriendLabel,
            value: el.referenceCode,
            displayseq: el.displaySeq
          });
        }
      });
    }

    residenceRadioOption.sort((a, b) => Number(a.displayseq) - Number(b.displayseq));
    residenceOption.map((el: any) => { delete el.displayseq });
    setResidenceRadioOption(residenceRadioOption);


    console.log('Drop down options', getDropOptionsRes);
  } catch (error) {
    console.error('Error fetching drop down options:', error);
  }
};

const uploadDocuments = async (
  stgCusProfId: string,
  documents: any,
  customerId?: any
): Promise<any> => {
  const dofAuthSessionValue: any =
    window.sessionStorage.getItem('dofAuthValues');
  const sessionStorageValues: any = JSON.parse(dofAuthSessionValue);
  const isStoreCodeFlow = window.sessionStorage.getItem('authKey')?.length ? false : true;
  const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');
  const payload: any = {
    isVerificationDocument: true,
    customerApprovalId: stgCusProfId,
    documents: documents,
    ...(customerId ? { identifierType: 'CUST' } : []),
  };

  const uploadDocRes: any = await uploadVerificationDocuments(
    payload,
    isStoreCodeFlow,
    accessToken
  );

  // eslint-disable-next-line no-console
  console.log('Upload Documents Res', uploadDocRes);

  if (uploadDocRes?.status == 200) {
    // eslint-disable-next-line no-console
    console.log('Upload document sucess', uploadDocRes?.data);
    return uploadDocRes.status
  } else {
    const documentType =
      documents[0]?.documentType == 'EMPDOC'
        ? 'Income'
        : documents[0]?.documentType == 'IDENTTY'
          ? 'Intellicheck'
          : documents[0]?.documentType == 'RESDOC'
            ? 'Residence'
            : documents[0]?.documentType == 'SELFIE'
              ? 'SELFIE'
              : '';
    // eslint-disable-next-line no-console
    console.log('Something went wrong document upload', uploadDocRes?.data);
    window.parent.postMessage(
      {
        status: 400,
        message: `The ${documentType} Document verification failed due to an technical issue.`,
        verificationProcessCompleted: false,
      },
      '*'
    );
  }
};

const setDocumentState = async (
  transactionId: any,
  residenceInfo?: any,
  incomeInfo?: any,
  identityInfo?: any,
  customerId?: string,
  type?: string
) => {

  console.log('setDocumentState fn');
  const dofAuthSessionValue: any =
    window.sessionStorage.getItem('dofAuthValues');
  const sessionStorageValues: any = JSON.parse(dofAuthSessionValue);
  console.log('Session Storage details', sessionStorageValues);
  const isStoreCodeFlow = window.sessionStorage.getItem('authKey') ? false : true;
  const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');
  const request: any = {
    identifier: type == 'EC' ? null : transactionId,
    documentStatus: 'signed',
    actionType: 'print',
    identifierType: 'CUST',
    customerVerificationDocument: 'true',
  };

  if (type == 'EC' && customerId) {
    request.customerId = customerId;
  }

  const getVerificationDocumentsRes: any = await getVerificationDocuments(
    request,
    isStoreCodeFlow,
    accessToken
  );

  if (
    getVerificationDocumentsRes &&
    getVerificationDocumentsRes?.data &&
    getVerificationDocumentsRes?.status == 200 &&
    getVerificationDocumentsRes?.data?.documents?.length > 0
  ) {
    const documents: any = getVerificationDocumentsRes?.data?.documents;

    const getMostRecentDocument = (docType: string, isBack?: boolean): any | undefined => {
      const filteredDocs = documents.filter((doc: any) =>
        isBack
          ? doc.documentName === docType && doc.documentUrl.includes('IdentityBackDocument')
          : doc.documentName === docType && !doc.documentUrl.includes('IdentityBackDocument')
      );

      filteredDocs.sort(
        (a: any, b: any) =>
          new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
      );

      return filteredDocs.length > 0 ? filteredDocs[0] : undefined;
    };

    const base64ToFile = (base64: string, fileName: string, mimeType: string): File => {
      // Ensure the Base64 string has the correct data URI prefix
      const fullBase64 = base64.startsWith('data:') ? base64 : `data:${mimeType};base64,${base64}`;

      // Convert Base64 to binary
      const byteString = atob(fullBase64.split(',')[1]);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }

      // Create a Blob from the binary data
      const blob = new Blob([byteArray], { type: mimeType });

      // Create a File object from the Blob
      return new File([blob], fileName, { type: mimeType });
    };

    const residenceDoc = getMostRecentDocument('ResidenceDocument');
    const incomeDoc = getMostRecentDocument('EmploymentDocument');
    const identityDocFront = getMostRecentDocument('IdentityDocument');
    const identityDocBack = getMostRecentDocument('IdentityDocument', true);
    // const identityDocFrontImage: any = getVerificationDocumentsRes?.data?.documents.filter((doc: any) => doc.documentName === "IdentityDocument" && !doc?.documentUrl?.includes('IdentityBackDocument'));
    // const identityDocBackImage: any = getVerificationDocumentsRes?.data?.documents.filter((doc: any) => doc.documentName === "IdentityDocument" && doc?.documentUrl?.includes('IdentityBackDocument'));

    const residenceFile = residenceDoc
      ? base64ToFile(
        residenceDoc.file,
        residenceDoc.documentUrl.split('/').pop() || 'ResidenceDocument.pdf',
        'application/pdf'
      )
      : null;
    const incomeFile = incomeDoc
      ? base64ToFile(
        incomeDoc.file,
        incomeDoc.documentUrl.split('/').pop() || 'EmploymentDocument.pdf',
        'application/pdf'
      )
      : null;
    // Convert Base64 to File objects
    const frontFile = identityDocFront
      ? base64ToFile(
        identityDocFront.file,
        identityDocFront.documentUrl.split('/').pop() || 'IdentityFrontDocument.pdf',
        'application/pdf'
      )
      : null;
    const backFile = identityDocBack
      ? base64ToFile(
        identityDocBack.file,
        identityDocBack.documentUrl.split('/').pop() || 'IdentityBackDocument.pdf',
        'application/pdf'
      )
      : null;

    console.log('documents response', residenceDoc, incomeDoc, frontFile, backFile);
    // setIdentityFrontDoc(identityDoc);
    // setResidenceDoc(residenceDoc);
    // setIncomeDoc(incomeDoc);
    residenceInfo.setResidenceDoc(residenceFile);
    incomeInfo.setResidenceDoc(incomeFile);
    identityInfo.setIdentityBackDocument(backFile);
    identityInfo.setIdentityFrontDocument(frontFile);
  }
};

const setCustomerDetails = (
  customerDetails: StgCustomerResponse,
  setIdentityInformation: React.Dispatch<React.SetStateAction<IdentityInterface>>,
  setResidenceInformation: (data: ResidenceInterface) => void,
  setIncomeInformation: (data: IncomeInterface) => void
) => {
  const latestRecord: StgIdentityRecord | undefined =
    customerDetails && customerDetails?.identityInfo
      ? customerDetails?.identityInfo.reduce((latest: StgIdentityRecord, current: StgIdentityRecord) => {
        return new Date(current.transactionDate) > new Date(latest.transactionDate)
          ? current
          : latest;
      })
      : undefined;
  if (customerDetails) {
    console.log("customerDetails ", customerDetails);
    const identityInfo: IdentityInterface = {
      firstName: customerDetails?.firstName,
      secondName: customerDetails?.secondName,
      paternalLastName: customerDetails?.paternalLastName,
      maternalLastName: customerDetails?.maternalLastName,
      curp: latestRecord && latestRecord?.curpId ? latestRecord?.curpId : customerDetails?.identityInfo[0]?.curpId || '',
      ineVoterid: latestRecord && latestRecord?.voterId ? latestRecord?.voterId : customerDetails?.identityInfo[0]?.voterId || '',
      gender: customerDetails?.genderType,
      dateOfBirth: customerDetails?.dateOfBirth,
      maritalStatus: customerDetails?.maritalStatusType,
      phoneNumber: customerDetails?.phoneNumber,
      countryCode: customerDetails?.countryCode,
      emailId: customerDetails?.emailAddress,
      racPromotions: customerDetails?.referralSourceType,
      rfc: latestRecord && latestRecord?.rfcId ? latestRecord?.rfcId : customerDetails?.identityInfo[0]?.rfcId,
      consentDate: customerDetails?.consentDate,

    };

    setIdentityInformation((prev: any) => ({
      ...prev,
      ...identityInfo
    }));
    const residenceInfo: ResidenceInterface = {
      street: customerDetails.addressInfo.addressLine1 || '',
      exteriorNumber: customerDetails.addressInfo.exteriorNumber || '',
      interiorNumber: customerDetails.addressInfo.interiorNumber || '',
      suburb: customerDetails.addressInfo.addressLine2 || '',
      postalCode: customerDetails.addressInfo.zipcode || '',
      city: customerDetails.addressInfo.city || '',
      state: customerDetails.addressInfo.state || '',
      timeOccupyingCurrentResidence: customerDetails.addressInfo.residenceTenureType || '',
      typeOfResidence: customerDetails.addressInfo.residenceType || '',
    };

    setResidenceInformation(residenceInfo);

    const incomeInfo: IncomeInterface = {
      typeOfIncomeProof: customerDetails.employmentInfo.incomeSourceType,
      companyName: customerDetails.employmentInfo.companyName || '',
      joiningDate: customerDetails.employmentInfo.employmentBeginDate || '',
      netMonthlyIncome: customerDetails.employmentInfo.takeHomePay || '',
      jobPosition: customerDetails.employmentInfo.jobPosition || '',
      jobType: customerDetails.employmentInfo.jobType || '',
    };

    setIncomeInformation(incomeInfo);
  }
}

const setExCustomerDetails = async (
  customerDetails: any,
  setIdentityInformation: any,
  setResidenceInformation: (data: ResidenceInterface) => void,
  setIncomeInformation: (data: IncomeInterface) => void,
  regionCode: string,
  decryptedData?: DecryptedData
) => {
  console.log(customerDetails.firstName);
  const identityInfo: IdentityInterface = {
    firstName: customerDetails?.firstName,
    secondName: customerDetails?.middleInitial || '',
    paternalLastName: customerDetails?.lastName,
    maternalLastName: customerDetails?.maternalLastName || '',
    curp: customerDetails?.curpId || '',
    ineVoterid: customerDetails?.voterId || '',
    gender: customerDetails?.gender || '',
    dateOfBirth: decryptedData?.dateOfBirth ? new Date(decryptedData.dateOfBirth).toISOString().split('T')[0] : '',
    maritalStatus: customerDetails.maritalStatus || '',
    phoneNumber: customerDetails.phones.find((phone: any) => phone.primary === 'Y')?.phoneNumber || '',
    emailId: customerDetails.emailAddress,
    racPromotions: customerDetails?.referralSource,
    rfc: decryptedData?.taxId || '',
    consentDate: customerDetails?.consentDate || '',
    countryCode: customerDetails.phones.find((phone: any) => phone.primary === 'Y')?.countryCode || (regionCode ? regionCode : ''),
  };

  setIdentityInformation((prev: any) => ({
    ...prev,
    ...identityInfo
  }));

  const residenceInfo: ResidenceInterface = {
    street: customerDetails?.addresses[0]?.addressLine1 || '',
    exteriorNumber: customerDetails?.addresses[0]?.exteriorNumber || '',
    interiorNumber: customerDetails?.addresses[0]?.interiorNumber || '',
    suburb: customerDetails?.addresses[0]?.addressLine2 || '',
    postalCode: customerDetails?.addresses[0]?.postalCode || '',
    city: customerDetails?.addresses[0]?.city || '',
    state: customerDetails?.addresses[0]?.state || '',
    timeOccupyingCurrentResidence: customerDetails?.residenceTenureType || '',
    typeOfResidence: customerDetails?.residenceType || ''
  };
  setResidenceInformation(residenceInfo);

  const incomeInfo: IncomeInterface = {
    typeOfIncomeProof: customerDetails?.employerReferences[0]?.incomeSourceType || '',
    companyName: customerDetails?.employerReferences[0]?.employerName || '',
    joiningDate: customerDetails?.employerReferences[0]?.employmentBeginDate || '',
    netMonthlyIncome: customerDetails?.employerReferences[0]?.takeHomePay || '',
    jobPosition: customerDetails?.employerReferences[0]?.jobPosition || '',
    jobType: customerDetails?.employerReferences[0]?.jobType || ''

  };

  setIncomeInformation(incomeInfo);
};
function MakeFeatureFlagObjFn(storeValue: any) {
  const tempFeatureFlagObj: any = {};
  for (let i = 0; i < storeValue?.length; i++) {
    tempFeatureFlagObj[storeValue[i]?.paramKeyName] = storeValue[i]?.paramValue;
  }
  console.log('tempFeatureFlagObj', tempFeatureFlagObj);
  return tempFeatureFlagObj;
}

export { GetDropDownOptions, uploadDocuments, setDocumentState, setCustomerDetails, setExCustomerDetails, MakeFeatureFlagObjFn };


// Helper function to safely access nested properties and return a default value if the property is not found.
export const getValue = (data: any, path: string, defaultValue: string = "") => {
  // Split the path into an array of keys
  const pathParts = path.split('.');

  // Use reduce to traverse the path and access the nested value
  const value = pathParts.reduce((acc, part) => acc?.[part], data);

  // Return the found value or the default value if it's undefined or null
  return value ?? defaultValue;
};

// Helper function to safely access an array at a given path, returning an empty array if not found.
export const getArrayValue = (data: any, path: string) => {
  // Split the path into an array of keys
  const pathParts = path.split('.');

  // Traverse the object along the path to get the value
  const value = pathParts.reduce((acc, part) => acc?.[part], data);

  // Return the value if it's an array, otherwise return an empty array
  return Array.isArray(value) ? value : [];
};

export const convertPDFToBase64 = async (pdfFile: Blob) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const reader = new FileReader();
      const result = await convertPDFToBlobURL(pdfFile);
      reader.onloadend = () => {
        // Once the reader finishes reading, resolve with the base64 string
        const base64String = (reader.result as string).split(',')[1]; // Strip off the data URL prefix
        resolve({
          url: result?.url,
          base64String
        });
      };
      reader.readAsDataURL(pdfFile);
      // Resolve with the generated URL
    } catch (err) {
      // If there's an error, reject the promise
      reject(err);
    }
  });
};

export const convertPDFToBlobURL = (pdfFile: Blob) => {
  return new Promise<any>((resolve, reject) => {
    try {
      // Generate an object URL for the PDF Blob
      const url = URL.createObjectURL(pdfFile);
      console.log('PDF Blob Url', url);
      resolve({ url }); // Resolve with the generated Blob URL
    } catch (err) {
      // If there's an error, reject the promise
      reject(err);
    }
  });
};

// Max base64 size for residence/income documents: 2MB
// A 2MB base64 string corresponds to ~1.5MB raw file, safely under the 2.9MB API limit
const RESIDENCE_INCOME_MAX_BASE64_BYTES = 2 * 1024 * 1024;

/**
 * Compress a PDF blob by re-rendering each page via canvas using pdfjs-dist.
 * Tries progressively lower scales until the base64 output fits under maxBase64Bytes.
 * Falls back to the original blob if compression fails.
 */
export const compressPDF = async (pdfFile: Blob, maxBase64Bytes: number): Promise<Blob> => {
  try {
    // pdfjs-dist is a project dependency (package.json). Import it directly.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pdfjsLib = require('pdfjs-dist/build/pdf');
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

    const arrayBuffer = await pdfFile.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

    // Try progressively lower scales until the output fits under the limit
    for (let scale = 1.0; scale >= 0.3; scale = parseFloat((scale - 0.1).toFixed(1))) {
      const outputPdf = new jsPDF();
      let firstPage = true;

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          console.warn('compressPDF: canvas context unavailable');
          return pdfFile;
        }

        await page.render({ canvasContext: ctx, viewport }).promise;

        const imgData = canvas.toDataURL('image/jpeg', 0.75);
        const pdfWidth = outputPdf.internal.pageSize.getWidth();
        const pdfHeight = (viewport.height * pdfWidth) / viewport.width;

        if (!firstPage) outputPdf.addPage();
        outputPdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
        firstPage = false;
      }

      const compressedBlob: Blob = outputPdf.output('blob');
      const base64Size = await new Promise<number>((res) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const b64 = (reader.result as string).split(',')[1] || '';
          res((b64.length * 3) / 4);
        };
        reader.readAsDataURL(compressedBlob);
      });

      console.log(`compressPDF: scale=${scale.toFixed(1)}, base64=${(base64Size / 1024 / 1024).toFixed(2)}MB`);

      if (base64Size <= maxBase64Bytes) {
        console.log('compressPDF: compression successful');
        return compressedBlob;
      }
    }

    console.warn('compressPDF: could not compress below limit, returning best attempt');
    return pdfFile;
  } catch (err) {
    console.error('compressPDF error, returning original:', err);
    return pdfFile;
  }
};

export const handleFile = async (file: any, maxBase64Bytes?: number) => {
  console.log('file handle ', file);
  const TARGET_BASE64 = maxBase64Bytes || RESIDENCE_INCOME_MAX_BASE64_BYTES;

  // Handle plain base64 strings from NAAT SDK (no data: prefix, no .type property).
  if (typeof file === 'string' && file && !file.startsWith('data:')) {
    console.log('handleFile: detected plain base64 string (NAAT), converting directly to PDF');
    const imageB64String: any = await convertImageToPDF(file);
    const base64Pdf: any = await convertPDFToBase64(imageB64String);
    return base64Pdf;
  }

  const fileType = file.type;
  console.log('File Type', fileType, file);
  if (fileType === "application/pdf") {
    // Compress PDF before converting to base64 to stay under the API limit
    let pdfToConvert: Blob = file;
    try {
      const testBase64 = await new Promise<string>((res) => {
        const reader = new FileReader();
        reader.onloadend = () => res((reader.result as string).split(',')[1] || '');
        reader.readAsDataURL(file);
      });
      const rawBase64Bytes = (testBase64.length * 3) / 4;
      console.log(`handleFile PDF: raw base64 size = ${(rawBase64Bytes / 1024 / 1024).toFixed(2)}MB`);

      if (rawBase64Bytes > TARGET_BASE64) {
        console.log('handleFile PDF: exceeds limit, attempting compression');
        pdfToConvert = await compressPDF(file, TARGET_BASE64);
      }
    } catch (e) {
      console.warn('handleFile PDF size check failed, proceeding with original:', e);
    }
    const pdfData: any = await convertPDFToBase64(pdfToConvert);
    return pdfData;
  } else if (fileType && fileType.startsWith("image/")) {
    return new Promise((resolve, reject) => {
      // Check if file exists
      if (!file) {
        return reject("No file selected");
      }

      // Maximum file size (2MB) — original logic preserved
      const maxSize = 2 * 1024 * 1024;
      let compressedFile: any = file;

      const compressImage = (file: any, quality = 0.8) => {
        return new Promise((resolve, reject) => {
          new Compressor(file, {
            quality, // Set quality (0.8 is default)
            maxWidth: 1024, // Max width (optional)
            maxHeight: 1024, // Max height (optional)
            success(result) {
              if (result.size <= maxSize) {
                // If the compressed image is under 2MB, resolve with Base64
                convertBlobToBase64(result)
                  .then((base64) => resolve(base64))
                  .catch((err) =>
                    reject("Error converting Blob to Base64: " + err)
                  );
              } else {
                // If file is still too large, lower the quality and retry
                if (quality > 0.1) {
                  // Try compressing with a lower quality
                  compressImage(result, quality - 0.1)
                    .then(resolve)
                    .catch(reject);
                } else {
                  // Can't compress further — use best result instead of rejecting
                  // This prevents the screen from getting stuck
                  console.warn('compressImage: could not reach 2MB target, using best result');
                  convertBlobToBase64(result)
                    .then((base64) => resolve(base64))
                    .catch((err) => reject("Error converting Blob to Base64: " + err));
                }
              }
            },
            error(err) {
              reject("Error during compression: " + err);
            },
          });
        });
      };

      // Start image compression
      compressImage(compressedFile)
        .then(async (compressFile: any) => {
          // Convert compressed file to Base64
          compressedFile = compressFile;
          console.log('compressed File', compressedFile);
          const imageB64String: any = await convertImageToPDF(
            compressedFile?.split(",")[1]
          );
          // Check final PDF base64 size and compress further if needed
          const pdfBlob = imageB64String;
          const finalPdf = await compressPDF(pdfBlob, TARGET_BASE64);
          const base64Pdf: any = await convertPDFToBase64(finalPdf);
          resolve(base64Pdf);
        })
        .catch((error) => {
          reject(error);
        });
    });
  } else if (
    !fileType &&
    file?.split(",")[0]?.includes("data:image/jpeg;base64")
  ) {
    return new Promise((resolve, reject) => {
      // Check if file exists
      if (!file) {
        return reject("No file selected");
      }

      const maxSize = 2 * 1024 * 1024; // 2MB — original logic preserved
      let compressedFile: any = file;

      const compressImage = (file: any, quality = 0.8) => {
        return new Promise((resolve, reject) => {
          new Compressor(file, {
            quality,
            maxWidth: 1024,
            maxHeight: 1024,
            success(result) {
              if (result.size <= maxSize) {
                // If the compressed image is under 2MB, resolve with Base64
                convertBlobToBase64(result)
                  .then((base64) => resolve(base64))
                  .catch((err) =>
                    reject("Error converting Blob to Base64: " + err)
                  );
              } else {
                // If file is still too large, lower the quality and retry
                if (quality > 0.1) {
                  // Try compressing with a lower quality
                  compressImage(result, quality - 0.1)
                    .then(resolve)
                    .catch(reject);
                } else {
                  // Can't compress further — use best result instead of rejecting
                  console.warn('compressImage: could not reach 2MB target, using best result');
                  convertBlobToBase64(result)
                    .then((base64) => resolve(base64))
                    .catch((err) => reject("Error converting Blob to Base64: " + err));
                }
              }
            },
            error(err) {
              reject("Error during compression: " + err);
            },
          });
        });
      };

      // Start image compression
      compressImage(compressedFile)
        .then(async (compressFile: any) => {
          // Convert compressed file to Base64
          compressedFile = compressFile;
          console.log('compressed File', compressedFile);
          const imageB64String: any = await convertImageToPDF(
            compressedFile?.split(",")[1]
          );
          // Check final PDF base64 size and compress further if needed
          const finalPdf = await compressPDF(imageB64String, TARGET_BASE64);
          const base64Pdf: any = await convertPDFToBase64(finalPdf);
          resolve(base64Pdf);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // Handle unsupported file types
  throw new Error("Unsupported file type");
};

const convertBlobToBase64 = (blob: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result); // Base64 string
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob); // Read the blob as a Base64 string
  });
};

export const convertImageToPDF = async (imageBase64: any) => {
  // eslint-disable-next-line no-console
  console.log(
    "Image Base4",
    imageBase64.replace(/^data:image\/png;base64,/, "")
  );
  const pdf = new jsPDF();

  // Remove the 'data:image/jpeg;base64,' part of the string
  const base64Image = imageBase64.replace(
    /^data:image\/(png|jpeg);base64,/,
    ""
  );

  const img = new Image();
  img.src = `data:image/jpeg;base64,${base64Image}`;

  return new Promise<Blob>((resolve, reject) => {
    img.onload = () => {
      // Get the natural width and height of the image
      const imgWidth = img.width;
      const imgHeight = img.height;

      // Get the page size of the PDF (A4 by default)
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Calculate the scaling factor to fit the image on the page while maintaining the aspect ratio
      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

      // Calculate the new dimensions to fit within the PDF page size
      const scaledWidth = imgWidth * scaleFactor;
      const scaledHeight = imgHeight * scaleFactor;

      // Add the image to the PDF with the calculated dimensions
      pdf.addImage(`data:image/jpeg;base64,${base64Image}`, 'JPEG', 0, 0, scaledWidth, scaledHeight);

      // Generate PDF Blob and resolve the promise
      const pdfBlob: Blob = pdf.output("blob"); // Generate PDF Blob
      resolve(pdfBlob);
    };

    img.onerror = (err) => {
      // eslint-disable-next-line no-console
      console.error("Error loading image:", err);
      reject(err);  // Reject if there's an error loading the image
    };
  });
};

export async function getBase64Size(base64String: string) {
  // Remove MIME prefix if present
  let base64 = base64String.split(',')[1] || base64String;

  let length = base64.length;

  // Calculate padding
  let padding = 0;
  if (base64.endsWith("==")) padding = 2;
  else if (base64.endsWith("=")) padding = 1;

  // Calculate the size in bytes
  return (length / 4) * 3 - padding;
}

export async function compressBase64Image(base64Str: string, quality = 0.7): Promise<string> {
  console.log('Inside the compressBase64Image function');

  // Validate base64 string format
  if (!base64Str || !/^data:image\/(jpeg|png);base64,/.test(base64Str)) {
    console.log('failed condition')
    return Promise.reject("Invalid base64 image format.");
  }

  return new Promise((resolve, reject) => {
    // Convert Base64 to Blob
    const byteString = atob(base64Str.split(',')[1]);
    console.log('byteString', byteString);
    const mimeString = base64Str.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: mimeString });

    // Use Compressor.js to compress the image
    new Compressor(blob, {
      quality: quality,
      success(result) {
        // Convert the compressed Blob back to Base64
        const reader = new FileReader();
        reader.readAsDataURL(result);
        reader.onloadend = () => {
          const compressedBase64 = reader.result as string;

          // Check if the compressed image size exceeds 2MB
          getBase64Size(compressedBase64).then(sizeInBytes => {
            // Target 2MB per NAAT doc so front+back combined stays under the 4.4MB API limit
            const maxSize = 2 * 1024 * 1024;

            if (sizeInBytes > maxSize) {
              console.log("Compressed image exceeds maximum size of 2MB. Adjusting quality...");
              // If the size exceeds, reduce quality and try again
              if (quality > 0.1) {
                compressBase64Image(base64Str, quality - 0.1)
                  .then(resolve)
                  .catch(reject);
              } else {
                console.log("In the else block");
                reject("Image size exceeds 2MB even after compression.");
              }
            } else {
              resolve(compressedBase64);
            }
          }).catch(reject);
        };
      },
      error(err) {
        console.log("Error during compression:", err);
        reject("Error during compression: " + (err?.message || "Unknown error"));
      },
    });
  });
}



export const fetchSecretValues = async (
  setSecretValues: (values: Partial<SecretValues> | '') => void
): Promise<void> => {
  const authKey = window.sessionStorage.getItem('authKey');
  const storeNumber = window.sessionStorage.getItem('storeNumber');
  const isStoreCodeFlow = !authKey;
  const accessToken = isStoreCodeFlow ? storeNumber || '' : authKey || '';

  console.log('isStoreCodeFlow ', isStoreCodeFlow);

  try {
    const response = await getNAATAccessLink(isStoreCodeFlow, accessToken);
    debugger

    if (response?.status === 200 && response.data) {
      const encryptedValues = response.data;

      const decryptedIvKey = encryptedValues.encryptedEncryptIvKey ? atob(encryptedValues.encryptedEncryptIvKey) : '';
      const decryptedKey = encryptedValues.encryptedEncryptKey ? atob(encryptedValues.encryptedEncryptKey) : '';

      // Decrypt sensitive values concurrently
      const [idvsApiKey, fadToken, googleMapsKey] = await Promise.all([
        decryptValue(encryptedValues.idvsApiKey, decryptedIvKey, decryptedKey),
        decryptValue(encryptedValues.fadToken, decryptedIvKey, decryptedKey),
        decryptValue(encryptedValues.googleMapsKey, decryptedIvKey, decryptedKey),
      ]);
      setSecretValues({
        googleMapsKey,
        fadToken,
        idvsApiKey,
        idvsScriptTag: encryptedValues.idvsScriptTag || '',
        idvsEndpoint: encryptedValues.idvsEndpoint || '',
        environment: encryptedValues.environment || '',
        fadAppName: encryptedValues.fadAppName || '',
      });
    } else {
      setSecretValues('');
    }
  } catch (error) {
    setSecretValues('');
  }
};

const decryptValue = async (encryptedData: string, iv: string, key: string): Promise<string> => {
  try {
    const decipher = createDecipheriv('aes-256-cbc', key, iv);
    let result = decipher.update(encryptedData, 'hex', 'utf8');
    result += decipher.final('utf8');
    return result;
  } catch (error) {
    console.error('Decryption error:', error);
    return '';
  }
};
